// The boot splash from public/index.html (mark + tips). Released once, by whoever knows the first screen is ready to show.
let released = false;

export function releaseBootSplash() {
  if (released) return;
  released = true;
  const splash = document.getElementById("boot-splash");
  if (!splash) return;
  splash.classList.add("done");
  setTimeout(() => splash.remove(), 320);
}
